<template>
  <section class="social-networks">
    <h3 class="the-footer-heading">Мы в социальных сетях</h3>
    <ul>
      <li
        v-for="network in socialNetworks"
        v-bind:key="network.name"
      >
        <a
          v-bind:href="network.url"
          v-bind:title="network.title"
          target="_blank"
          rel="noopener noreferrer"
        >
          <font-awesome-icon v-bind:icon="network.icon"></font-awesome-icon>
        </a>
      </li>
    </ul>
  </section>
</template>

<script>
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import {
  faFacebook,
  faYoutube,
  faTelegram,
  faInstagram,
  faWhatsapp
} from '@fortawesome/free-brands-svg-icons'

export default {
  name: 'SocialNetworks',
  data () {
    return {
      socialNetworks: [
        {
          name: 'Instagram',
          title: 'Instagram',
          icon: faInstagram,
          url: 'https://www.instagram.com/stylegold.brest/'
        },
        {
          name: 'Facebook',
          title: 'Facebook',
          icon: faFacebook,
          url: 'https://www.facebook.com/stylegold2'
        },
        {
          name: 'YouTube',
          title: 'YouTube',
          icon: faYoutube,
          url: 'https://www.youtube.com/channel/UCmDXKO1TSaMSE5DhMQOqitA'
        },
        {
          name: 'Telegram',
          title: 'Telegram',
          icon: faTelegram,
          url: 'https://t.me/stylegoldby'
        },
        {
          name: 'WhatsApp',
          title: 'WhatsApp',
          icon: faWhatsapp,
          url: 'https://wa.me/qr/NWCITPEMLV6CM1'
        }
      ]
    }
  },
  components: {
    FontAwesomeIcon
  }
}
</script>

<style scoped lang="scss">
  .social-networks {
    span { display: inline-block; }
    ul {
      display: inline-block;
      font-size: 22px;
      margin: 0;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/the-footer/SocialNetworks.vue